
import React, { useEffect, useRef, useState } from "react";

import { GanttColumn } from "./types";

import ToggleTaskIcon from "../AnimatedIcons/ToggleTaskIcon/ToggleTaskIcon";
import ToggleGroupIcon from "../AnimatedIcons/ToggleGroupIcon/ToggleGroupIcon";

type Props = {
  showVerticalBorders: boolean
  column: GanttColumn
  item: any
  isRowActive: boolean

  onToggleCollapse: (group_id: string) => void
  onToggleCollapseTask: (task_id: string) => void
}

const GanttTableBodyCell = (props: Props) => {

  const input_ref: any = useRef()

  const [ editing, setEditing ] = useState(false)
  const [ cell, setCell ] = useState('')

  const getClassName = () => {

    let class_name = 'content'

    if (props.item.schema === 'group') {

        class_name += ' group'
    }

    if (props.column.field === 'name') {

        class_name += ' editable'
    }

    return class_name
  }

  const getPadding = () => {

    let left = 4

    if (props.column.field === 'name') {

        left += props.item.level * 16
    }

    return left
  }

  const handleClick = (e: any) => {

    if (!props.isRowActive) {

        return
    }
  }

  const toggleCollapse = (e: any) => {
    e.stopPropagation()
    e.preventDefault()

    props.onToggleCollapse(props.item._id)
  }

  const toggleCollapseTask = (e: any) => {
    e.stopPropagation()
    e.preventDefault()

    props.onToggleCollapseTask(props.item._id)
  }

  useEffect(() => {

    if (props.item[props.column.field] !== cell) {

      setCell(props.item[props.column.field])
    }
  }, [ props.item ])

  return (
    <div
      className={`td ${props.showVerticalBorders ? 'with-border': ''}`}
      style={{
        width: props.column.width,
        paddingLeft: getPadding()
      }}
    >
      {props.column.field === 'name' && props.item.schema === 'task' && (
        <>
          {!props.item.hasSubTasks && (
            <span className="fake-icon"></span>
          )}
          {props.item.hasSubTasks && (
            <span
              className={`task-icon ${props.item.isCollapsed ? 'collapsed' : 'expanded'}`}
              onClick={toggleCollapseTask}
            >
              <ToggleTaskIcon isOpen={!props.item.isCollapsed} size={16} />
            </span>
          )}
        </>
      )}
      {props.column.field === 'name' && props.item.schema === 'group' && (
        <span
          className={`group-icon ${props.item.isCollapsed ? 'collapsed' : 'expanded'}`}
          onClick={(e: any) => toggleCollapse(e)}
          style={{
            height: 21,
          }}
        >
          <ToggleGroupIcon isOpen={!props.item.isCollapsed} size={16} />
        </span>
      )}
      {!editing && (
        <span className={getClassName()}
          style={{
            width: `calc(100% - 24px)`
          }}
          onClick={(e: any) => handleClick(e)}
        >
          {props.column.render ? props.column.render(cell, props.item) : cell}
        </span>
      )}
      {editing && (
        <input
          ref={input_ref}
          className="content"
          type="text"
          value={cell}
          // onChange={onChange}
          // onKeyDown={onKeyDown}
          // onKeyUp={onKeyUp}
          // onBlur={() => handleBlur()}
          onClick={(e: any) => e.stopPropagation()}
        />
      )}
    </div>
  )
}

export default GanttTableBodyCell
